<app-entity-page
[closeClicked]="closeClicked"
[detailsContentTitle]="(objectDetails?.objectTitle || '' | translateLang | async) + 
                          (objectDetails?.isMandatory ? ('-' + ('iaa.mandatoryObject' | translate)) : '')"
 [loading]="objectLoading">
 <ng-template #detailsContent>
<div class="object-container">
  <div *ngIf="!objectLoading">
    <div *ngIf="true" class="object-wrapper">
      <div class="object-content">
        <div [ngClass]="{'object-content-body':true,'en': (currentLanguage$ | async) === 'en'}">
          <div
          class="description"
          [ngClass]="{ 'en': (currentLanguage$ | async) === 'en' }"
          >
            {{
              (currentLanguage$ | async) === 'en'
                ? objectDetails?.objectDescriptionEng?.join(', ')
                : objectDetails?.objectDescription?.join(', ')
            }}
            <span *ngIf="objectDetails?.needsResearch" class="robert-comment">
              {{ 'iaa.general.needsResearch' | translate }}
            </span>
          </div>
          <div class="content-container">
            <div class="flex flex-column col-8" *ngIf="!!rows">
              <app-ordinary-object-row *ngIf="!rows.firstRow.isEmpty" [title1]="rows.firstRow.firstTitle"
                [value1]="rows.firstRow.firstValue" [title2]="rows.firstRow.secondTitle" [value2]="rows.firstRow.secondValue"
                [title3]="rows.firstRow.thirdTitle" [value3]="rows.firstRow.thirdValue"/>
              <app-ordinary-object-row *ngIf="!rows.secondRow.isEmpty" [title1]="rows.secondRow.firstTitle"
                [value1]="rows.secondRow.firstValue" [title2]="rows.secondRow.secondTitle" [value2]="rows.secondRow.secondValue"
                [title3]="rows.secondRow.thirdTitle" [value3]="rows.secondRow.thirdValue"/>
              <app-ordinary-object-row *ngIf="!rows.thirdRow.isEmpty" [title1]="rows.thirdRow.firstTitle"
                [value1]="rows.thirdRow.firstValue" [title2]="rows.thirdRow.secondTitle" [value2]="rows.thirdRow.secondValue"
                [title3]="rows.thirdRow.thirdTitle" [value3]="rows.thirdRow.thirdValue"/>
              <app-ordinary-object-row *ngIf="!rows.fourthRow.isEmpty" [title1]="rows.fourthRow.firstTitle"
                [value1]="rows.fourthRow.firstValue" [title2]="rows.fourthRow.secondTitle" [value2]="rows.fourthRow.secondValue"
                [title3]="rows.fourthRow.thirdTitle" [value3]="rows.fourthRow.thirdValue"/>
              <app-ordinary-object-row *ngIf="!rows.fifthRow.isEmpty" [title1]="rows.fifthRow.firstTitle"
                [value1]="rows.fifthRow.firstValue" [title2]="rows.fifthRow.secondTitle" [value2]="rows.fifthRow.secondValue"
                [title3]="rows.fifthRow.thirdTitle" [value3]="rows.fifthRow.thirdValue" />
              <app-ordinary-object-row *ngIf="!rows.sixthRow.isEmpty" [title1]="rows.sixthRow.firstTitle"
                [value1]="rows.sixthRow.firstValue" [title2]="rows.sixthRow.secondTitle" [value2]="rows.sixthRow.secondValue"
                [title3]="rows.sixthRow.thirdTitle" [value3]="rows.sixthRow.thirdValue"/>
              <app-ordinary-object-row *ngIf="!rows.seventhRow.isEmpty" [title1]="rows.seventhRow.firstTitle"
                [value1]="rows.seventhRow.firstValue" [title2]="rows.seventhRow.secondTitle"
                [value2]="rows.seventhRow.secondValue" [title3]="rows.seventhRow.thirdTitle"
                [value3]="rows.seventhRow.thirdValue" [isSeventhRow]="true"(handleClickHachraza)="handleClickHachraza($event)"/>
              <app-ordinary-object-row *ngIf="!rows.eighthRow.isEmpty" [title1]="rows.eighthRow.firstTitle"
                [value1]="rows.eighthRow.firstValue" [title2]="rows.eighthRow.secondTitle" [value2]="rows.eighthRow.secondValue"
                [title3]="rows.eighthRow.thirdTitle" [value3]="rows.eighthRow.thirdValue"/>
              <app-ordinary-object-row *ngIf="!rows.ninthRow.isEmpty" [title1]="rows.ninthRow.firstTitle"
                [value1]="rows.ninthRow.firstValue" [title2]="rows.ninthRow.secondTitle" [value2]="rows.ninthRow.secondValue"
                [title3]="rows.ninthRow.thirdTitle" [value3]="rows.ninthRow.thirdValue"/>
              <app-ordinary-object-row *ngIf="!rows.tenthRow.isEmpty" [title1]="rows.tenthRow.expeditionTitle"
                [value1]="rows.tenthRow.expeditionValue" [title2]="rows.tenthRow.licencesTitle"
                [value2]="licencesValue"/>
              <app-ordinary-object-row *ngIf="!rows.eleventhRow.isEmpty" [title1]="rows.eleventhRow.firstTitle"
                [value1]="rows.eleventhRow.firstValue" [title2]="rows.eleventhRow.secondTitle"
                [value2]="rows.eleventhRow.secondValue" [title3]="rows.eleventhRow.thirdTitle"
                [value3]="rows.eleventhRow.thirdValue"/>
              <app-ordinary-object-row *ngIf="!rows.twelvthRow.isEmpty" [title1]="rows.twelvthRow.firstTitle"
                [value1]="rows.twelvthRow.firstValue" [title2]="rows.twelvthRow.secondTitle"
                [value2]="rows.twelvthRow.secondValue" [title3]="rows.twelvthRow.thirdTitle"
                [value3]="rows.twelvthRow.thirdValue"/>
            </div>
            <app-image-gallery *ngIf="images?.length" [thumbnails]="thumbnails" [images]="images" class="gallery" [objectName]="('iaa.general.object' | translate) + ' ' + (objectDetails?.objectTitle || '' | translateLang | async)"/>
          </div>
        </div>
      </div>
   </div>
  </div>
</div>
</ng-template>